import type { IconData } from '@stacksjs/iconify-core'

export const travelCar: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 1h9l7 7v4a3 3 0 0 1-5.83 1H5.83A3.001 3.001 0 0 1 0 12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelCar
